<template>
    <footer>
        <div class="container">
            <div class="logo">
                GameSpot
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>

</style>